import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { Icon, IconButton } from "@material-ui/core";
import { NavigationProps } from "../../Types/Types";

export interface NavigationMobileProps extends NavigationProps {}

const NavigationMobile = ({ items }: NavigationMobileProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-controls="mobile-navigation"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Icon>menu</Icon>
      </IconButton>
      <Menu
        id="mobile-navigation"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {items
          .filter((item) => item.isVisible)
          .map((item) => (
          <MenuItem onClick={item.onClick} key={item.label}>
            <Icon style={{marginRight: 16}}>{item.icon}</Icon>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default NavigationMobile;
